export default __webpack_public_path__ + "static/media/team-photo-2022.058db606.png";